import { BarcodeDimensions } from "./barcode-dimensions";
import { BarcodeStatistics } from "./barcode-statistics";
import { FeeGroup } from "./fee-group";

export class LibraryConfiguration {
  public renewMediaData: boolean;

  constructor(
    public barcodeDimensions: BarcodeDimensions,
    public barcodeStatistics: BarcodeStatistics,
    public useBarcodeSignature: boolean,
    public useBarcodeSignatureSeperate: boolean,
    public useMediaBywords: boolean,
    public useExtendedMediaStructure: boolean,
    public signatureDimensions: BarcodeDimensions,
    public overtakenReminderDays: number,
    public overtakenReminderInitialMailEnabled: boolean,
    public maxReservationCount: number,
    public reservationAvailabilityDuration: number | null = null,
    public hasLogo?: boolean,
    renewMediaData?: boolean,
    public notificationMessage?: string,
    public bank?: {
      name: string;
      iban: string;
      bic: string;
    },
    public contact?: {
      email: string;
      telephone: string;
    },
    public storeRentalHistory?: boolean,
    public feegroupMailContent?: string,
    public recycleMediaIds: boolean = false,
    public recycleReaderIds: boolean = false,
    public printSignatureRectangle: boolean = false,
    public printClassBackgroundOnSignatureSticker: boolean = false,
    public printSeriesOnSignatureSticker: boolean = false,
    public printMediaIdOnSignatureSticker: boolean = true,
    public printAntolinIconOnSignatureSticker: boolean = true,
    public printCreateDateOnMediaBarcode: boolean = false,
    public useBigSignatureStickerMode: boolean = false,
    public notificationsEnabled: boolean = false,
    public rosterVisibleWeeks: number = 11,
    public billClosedDays = true,
    public fairnessDays = 0,
    public divbibOrdinal?: string,
    public divibibGroup?: string,
    public defaultFeeGroup: FeeGroup | null = null,
    public feeGroupControlsMedia2goStatus: boolean = false,
    public statsCountDivibibEnabledReaders: boolean = false,
    public optimizeLabelsForThermalTransfer: boolean = false,
    public allowReaderIdOverride: boolean = false,
    public useReaderTag: boolean = false
  ) {
    this.renewMediaData = renewMediaData || false;
  }

  public static clone(config: LibraryConfiguration): LibraryConfiguration {
    return new LibraryConfiguration(
      BarcodeDimensions.clone(config.barcodeDimensions),
      BarcodeStatistics.clone(config.barcodeStatistics),
      config.useBarcodeSignature,
      config.useBarcodeSignatureSeperate,
      config.useMediaBywords,
      config.useExtendedMediaStructure,
      BarcodeDimensions.clone(config.signatureDimensions),
      config.overtakenReminderDays,
      config.overtakenReminderInitialMailEnabled,
      config.maxReservationCount,
      config.reservationAvailabilityDuration,
      config.hasLogo,
      config.renewMediaData,
      config.notificationMessage,
      config.bank,
      config.contact,
      config.storeRentalHistory,
      config.feegroupMailContent,
      config.recycleMediaIds,
      config.recycleReaderIds,
      config.printSignatureRectangle,
      config.printClassBackgroundOnSignatureSticker,
      config.printSeriesOnSignatureSticker,
      config.printMediaIdOnSignatureSticker,
      config.printAntolinIconOnSignatureSticker,
      config.printCreateDateOnMediaBarcode,
      config.useBigSignatureStickerMode,
      config.notificationsEnabled,
      config.rosterVisibleWeeks,
      config.billClosedDays,
      config.fairnessDays,
      config.divbibOrdinal,
      config.divibibGroup,
      config.defaultFeeGroup,
      config.feeGroupControlsMedia2goStatus,
      config.optimizeLabelsForThermalTransfer,
      config.allowReaderIdOverride,
      config.useReaderTag
    );
  }

  // removed backend db structure
}

